import { useEffect, useState } from 'react';

import { ReactComponent as IconCaution } from 'styles/images/icon_caution.svg';
import { ReactComponent as IconSuccess } from 'styles/images/icon_success.svg';
import { ReactComponent as IconWarning } from 'styles/images/icon_warning.svg';

export const Modal = ({ title, contents, close }) => {
  return (
    <div className='dimmed-popup-center fix-bottom text-align-left'>
      <div className='pop-con-wrap'>
        <div className='pop-con'>
          <p className='pop-tit'>{title}</p>
          <span className='pop-info-txt'>{contents}</span>
        </div>
        <div className='pop-btm'>
          <button className='btn btm-btn-primary' onClick={close}>
            <span>다음</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export const ModalWithIcon = ({ type, title, contents, close }) => {
  return (
    <div className='dimmed-popup-center fix-bottom text-align-left'>
      <div className='pop-con-wrap'>
        <div className='pop-con'>
          {type === 'success' ? <IconSuccess className='icon_success' /> : <IconCaution className='icon_caution' />}

          <p className='pop-tit'>{title}</p>
          <span className='pop-info-txt'>{contents}</span>
        </div>
        <div className='pop-btm'>
          <button className='btn btm-btn-primary' onClick={close}>
            <span>확인</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export const ModalWithIconAndTimer = ({ type, title, contents, close, time }) => {
  const [count, setCount] = useState(time / 1000);

  useEffect(() => {
    if (count <= 0) close();

    const interval = setInterval(() => {
      if (count > 0) setCount(count - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [count]);

  return (
    <div className='dimmed-popup-center'>
      <div className='pop-con-wrap'>
        <div className='pop-con'>
          {type === 'success' ? <IconSuccess className='icon_success' /> : <IconCaution className='icon_caution' />}
          <p className='pop-tit'>{title}</p>
          <span className='pop-info-txt'>{contents}</span>
        </div>
        <div className='pop-btm'>
          <button className='btn btm-btn-primary' onClick={close}>
            <span>확인</span>
          </button>
        </div>
      </div>
      <span className='floating-bottom-text'>
        <span>{count}</span>초 후 자동으로 닫힙니다.
      </span>
    </div>
  );
};

export const NotFoundPtModal = ({ hspNm, hspTel, close }) => {
  return (
    <div className='dimmed-popup-center'>
      <div className='pop-con-wrap'>
        <div className='pop-con'>
          <IconWarning className='icon_warning' />
          <p className='pop-tit'>환자 정보 확인 불가</p>
          <span className='pop-info-txt'>
            병원에 등록된 환자 정보가 없어요 방문 및 진료 기록이 없으신 경우 환자 정보 확인을 더 이상 진행할 수 없어요.
            병원 진료 예약 등 서비스 이용이 필요하신 경우 콜센터를 통해 먼저 문의해 주세요.
          </span>

          {/* 환자 정보 확인 불가 팝업 컨텐츠  */}
          <div className='pop-box-wrap center'>
            <ul className='pop-list'>
              <li>
                <h3 className='body-tit-01'>{hspNm} 콜센터</h3>
                <p className='body-tit-04'>{hspTel}</p>
              </li>
            </ul>
          </div>
        </div>

        <div className='pop-btm'>
          <button className='btn btm-btn-primary' onClick={close}>
            <span>카톡으로 돌아가서 문의하기</span>
          </button>
        </div>
      </div>
    </div>
  );
};
